/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_UnavailableInputs */

const en_signin_sso_x15_unavailable = /** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single sign-on is not set up for this workspace right now. Sign in another way, or ask your admin.`)
};

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const ar_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const he_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const ur_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const es_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const fr_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const de_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const pt_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const hi_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/** @type {(inputs: Signin_Sso_X15_UnavailableInputs) => LocalizedString} */
const bn_signin_sso_x15_unavailable = en_signin_sso_x15_unavailable;

/**
* | output |
* | --- |
* | "Single sign-on is not set up for this workspace right now. Sign in another way, or ask your admin." |
*
* @param {Signin_Sso_X15_UnavailableInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_unavailable = /** @type {((inputs?: Signin_Sso_X15_UnavailableInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_UnavailableInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_x15_unavailable(inputs)
	if (locale === "he") return he_signin_sso_x15_unavailable(inputs)
	if (locale === "ur") return ur_signin_sso_x15_unavailable(inputs)
	if (locale === "es") return es_signin_sso_x15_unavailable(inputs)
	if (locale === "fr") return fr_signin_sso_x15_unavailable(inputs)
	if (locale === "de") return de_signin_sso_x15_unavailable(inputs)
	if (locale === "pt") return pt_signin_sso_x15_unavailable(inputs)
	if (locale === "hi") return hi_signin_sso_x15_unavailable(inputs)
	if (locale === "bn") return bn_signin_sso_x15_unavailable(inputs)
	return /** @type {LocalizedString} */ ("Single sign-on is not set up for this workspace right now. Sign in another way, or ask your admin.")
});